import { useEffect } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CustomerFragmentFragment, useCustomersQuery } from '../../../api/gql';
import { notify } from '../../../utils/notification';
import { CustomersTable } from './modules/CustomersTable';

type CustomersOverviewProps = {
  onCustomerChoose: (customer: CustomerFragmentFragment) => void;
};

export const CustomersOverview = ({ onCustomerChoose }: CustomersOverviewProps) => {
  const { t } = useTranslation();
  const { data, isLoading, error } = useCustomersQuery({});

  useEffect(() => {
    if (error) {
      console.error(error);
      notify.negative({ message: t('query.error.default') });
    }
  }, [error, t]);

  return (
    <Box>
      <CustomersTable loading={isLoading} customers={data?.customers} onCustomerChoose={onCustomerChoose} />
    </Box>
  );
};
